// Keep a CSS variable in sync with the real visible viewport height.
//
// Why: `.app-shell` and MainContainer size the app with 100dvh. In some
// embedded WebViews (the MDM browser on school tablets) 100vh / 100dvh
// resolve to the "large viewport" that includes a browser-controls strip
// the app never shows, so the document ends up ~1em taller than what is
// visible, the whole page becomes scrollable and the fixed top / bottom
// navbars get clipped. window.innerHeight is the visible height in those
// WebViews, so we expose it as --app-height and let CSS fall back to dvh
// where JS hasn't run yet.
const VAR = "--app-height";

const update = () => {
  if (typeof window === "undefined" || !document.documentElement) return;
  const h = window.innerHeight;
  if (h > 0) document.documentElement.style.setProperty(VAR, `${h}px`);
};

export const installAppHeight = () => {
  update();
  window.addEventListener("resize", update);
  window.addEventListener("orientationchange", update);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", update);
  }
};
